import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
    name: 'localDate'
})
export class LocalDatePipe implements PipeTransform {

    transform(value: Date | string | null): string | null {
        if (!value) {
            return null;
        }

        // Parse the date and force it to be treated as UTC, ignoring any timezone info
        // Then convert to local time
        return moment.utc(moment(value).format('YYYY-MM-DD HH:mm:ss')).local().format('DD/MM/YYYY');
    }

}
